module.exports = __webpack_public_path__ + "img/map.21e3ff8d.png";